export const getDepletionType = (dueTodayList) => {
  let depletionType;

  if (!dueTodayList || dueTodayList.length === 0) {
    return depletionType;
  }
  const { installationType } = dueTodayList[0];
  if (installationType) {
    if (installationType === 'Professional SetUp') {
      depletionType = 'O';
    } else if (installationType === 'Self SetUp') {
      depletionType = 'F';
    }
  }

  return depletionType;
};

export const getRebateOfferAmount = (cartTotalDiscounts) => {
  let rebateOfferAmount = '';

  if (
    cartTotalDiscounts &&
    cartTotalDiscounts.barCodeOfferAppliedOnOrder &&
    cartTotalDiscounts.discountDetails &&
    cartTotalDiscounts.discountDetails.length > 0
  ) {
    const { discountDetails = [] } = cartTotalDiscounts;
    const instantDiscount = discountDetails?.find((discountDetail) => discountDetail?.discountType === 'Instant');
    if (instantDiscount?.discountItems) {
      const rebateItems = instantDiscount.discountItems.find((item) => item?.promoType?.toUpperCase() === 'REBATE');
      if (rebateItems?.offerAmount) {
        rebateOfferAmount = rebateItems.offerAmount;
      }
    }
  }

  return rebateOfferAmount;
};

export const focusToMiniCartToglButn = () => {
  const elem = document.querySelector('[data-testid="miniCartToggleButton"]');
  if (elem) {
    elem.setAttribute('tabindex', '0');
    elem.focus();
  }
};
